import { render } from "./local-grid.vue?vue&type=template&id=3b989278&scoped=true"
import script from "./local-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./local-grid.vue?vue&type=script&setup=true&lang=js"

import "./local-grid.vue?vue&type=style&index=0&id=3b989278&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b989278"],['__file',"src/components/local-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b989278"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b989278', __exports__)) {
    api.reload('3b989278', __exports__)
  }
  
  module.hot.accept("./local-grid.vue?vue&type=template&id=3b989278&scoped=true", () => {
    api.rerender('3b989278', render)
  })

}


export default __exports__